import React from 'react';
import { useProjects } from '../context/ProjectContext';
import ListView from '../components/views/ListView';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Archive = () => {
  const { projects, deleteProject } = useProjects();

  const allArchived = projects.filter(p => p.status === 'Archived');

  return (
    <div className="space-y-6">
       <div className="bg-gray-50 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-700 rounded-xl p-6 flex items-center gap-4">
         <div className="p-4 bg-green-100 dark:bg-green-900/30 text-green-600 rounded-full">
            <SafeIcon icon={FiIcons.FiArchive} className="text-2xl" />
         </div>
         <div>
           <h2 className="text-lg font-bold dark:text-white">Project Archive</h2>
           <p className="text-gray-500 dark:text-gray-400">View history of completed and signed-off projects.</p>
         </div>
       </div>

       {allArchived.length > 0 ? (
         <ListView 
           projects={allArchived} 
           onEdit={() => {}} 
           onDelete={deleteProject}
         />
       ) : (
         <div className="text-center py-20 bg-white dark:bg-gray-800 rounded-2xl border border-dashed border-gray-300 dark:border-gray-700">
           <SafeIcon icon={FiIcons.FiInbox} className="mx-auto text-4xl text-gray-300 mb-4" />
           <p className="text-gray-500">No archived projects yet.</p>
         </div>
       )}
    </div>
  );
};

export default Archive;